import { render, staticRenderFns } from "./Gallary.vue?vue&type=template&id=1f7378e9&scoped=true&"
import script from "./Gallary.vue?vue&type=script&lang=js&"
export * from "./Gallary.vue?vue&type=script&lang=js&"
import style0 from "./Gallary.vue?vue&type=style&index=0&id=1f7378e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7378e9",
  null
  
)

export default component.exports